module.exports = __webpack_public_path__ + "static/media/poikiliasm_thumb1.a6f51dde.jpg";